import './ItemChat.css'
import {defaultAvatarUrl} from '@utils/Const'
import {Box, Button} from '@chakra-ui/react'
const ItemChatVideo = ({avatar, text, url, handleNext}: any) => {
  return (
    <div className={`chat-message`}>
      <img src={defaultAvatarUrl} alt="Avatar" className="avatar" />
      <div className="message-bot">
        <Box
          as="video"
          controls
          src={url}
          objectFit="contain"
          sx={{
            aspectRatio: '16/9',
          }}
        />
        <Button onClick={handleNext}>{'Done'}</Button>
      </div>
    </div>
  )
}

export default ItemChatVideo
